// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-header {
  right: 2em;
  top: -0.15em;
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/expenditure-workflows/expenditure-workflows.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;AACF","sourcesContent":[".date-header{\n  right: 2em;\n  top:-0.15em;\n  position: absolute;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
